export const LOAD_GLACCOUNTS = "LOAD_GLACCOUNTS"
export const loadGLAccountsAction = GLAccounts => ({
   type: LOAD_GLACCOUNTS,
   payload: GLAccounts
})